export const chapter4Translations = {
  name: "제4장: 십자가형과 부활",
  description: "예수님의 수난, 죽음 그리고 부활의 이야기를 따라가세요",
  spiritualWisdom: "십자가는 사랑의 궁극적인 승리와 죄에 대한 승리의 상징입니다. 부활은 우리에게 그리스도 안에서 새로운 생명의 약속을 줍니다.",
  
  levels: {
    40: {
      name: "체포",
      challenge: "겟세마네 동산에서의 예수님의 체포에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "예수님은 어느 동산에서 체포되셨습니까?",
          options: ["겟세마네", "에덴", "감람", "나사렛"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "유다는 예수님을 배신하기 위해 어떤 신호를 사용했습니까?",
          options: ["악수", "입맞춤", "말", "몸짓"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "어떤 제자가 칼로 대제사장의 종의 귀를 베었습니까?",
          options: ["야고보", "요한", "베드로", "안드레"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "겟세마네는 감람산 기슭의 동산입니다",
        "유다는 은 30냥에 예수님을 배신했습니다",
        "예수님은 종의 귀를 기적적으로 치유하셨습니다"
      ],
      
      funFacts: [
        "겟세마네는 '기름틀'을 의미하며, 올리브 기름이 만들어지는 곳이었습니다",
        "예수님의 체포는 한밤중에 일어났습니다",
        "예수님은 평화롭게 가셨고, 제자들에게 폭력으로 저항하지 말라고 하셨습니다"
      ]
    },

    41: {
      name: "베드로의 부인",
      challenge: "베드로가 예수님을 세 번 부인한 것에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "베드로는 몇 번 예수님을 부인했습니까?",
          options: ["한 번", "두 번", "세 번", "네 번"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "베드로의 세 번째 부인 후에 무슨 일이 일어났습니까?",
          options: ["해가 떠올랐다", "닭이 울었다", "번개가 쳤다", "지진이 일어났다"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "베드로가 예수님을 부인한 곳은 어디였습니까?",
          options: ["성전에서", "대제사장의 뜰에서", "빌라도의 궁전에서", "겟세마네에서"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "예수님은 베드로의 부인을 예언하셨습니다",
        "베드로는 통곡하며 회개했습니다",
        "모든 일이 같은 밤에 일어났습니다"
      ],
      
      funFacts: [
        "예수님은 '닭 울기 전에 네가 세 번 나를 부인하리라'고 말씀하셨습니다",
        "베드로의 부인은 인간의 약함과 하나님의 용서의 강력한 예입니다",
        "베드로는 나중에 교회의 위대한 지도자가 되었습니다"
      ]
    },

    42: {
      name: "빌라도 앞의 예수님",
      challenge: "로마 총독 앞에서의 예수님의 재판에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "빌라도는 누구였습니까?",
          options: ["제자", "로마 총독", "대제사장", "바리새인"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "빌라도는 예수님에게서 무엇을 찾지 못했습니까?",
          options: ["지혜", "죄", "용기", "힘"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "빌라도는 자신의 무죄를 상징하기 위해 무엇을 했습니까?",
          options: ["손을 씻었다", "옷을 찢었다", "금식했다", "기도했다"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "빌라도는 예수님을 석방하기를 원했습니다",
        "군중은 예수님의 십자가형을 요구했습니다",
        "빌라도는 정치적 압력에 굴복했습니다"
      ],
      
      funFacts: [
        "빌라도의 아내는 그에게 예수님께 대해 아무것도 하지 말라고 경고했습니다",
        "손 씻기는 유대 전통에서 무죄의 상징이었습니다",
        "빌라도의 결정은 인간 정의의 실패를 보여주었습니다"
      ]
    },

    43: {
      name: "바라바냐 예수냐",
      challenge: "군중이 바라바를 선택한 것에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "바라바는 누구였습니까?",
          options: ["제자", "강도", "제사장", "왕"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "유대 축제 동안 빌라도는 무엇을 할 수 있었습니까?",
          options: ["죄수 한 명을 석방하다", "세금을 면제하다", "잔치를 베풀다", "성전을 폐쇄하다"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "군중은 누구를 선택했습니까?",
          options: ["예수", "바라바", "둘 다", "아무도"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "유월절 축제 기간이었습니다",
        "군중은 예수님을 십자가에 못 박으라고 요구했습니다",
        "바라바는 살인자이자 반역자였습니다"
      ],
      
      funFacts: [
        "바라바라는 이름은 '아버지의 아들'을 의미합니다",
        "바라바의 석방은 그리스도의 희생의 상징입니다",
        "우리 모두는 바라바입니다, 예수님의 희생으로 해방되었습니다"
      ]
    },

    44: {
      name: "채찍질과 가시 면류관",
      challenge: "예수님의 고난에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "군인들은 예수님의 머리에 무엇을 씌웠습니까?",
          options: ["금관", "가시 면류관", "꽃관", "터번"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "군인들은 어떻게 예수님을 조롱했습니까?",
          options: ["왕이라고 부르며", "돌을 던지며", "감옥에 가두며", "무시하며"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "로마의 채찍에는 무엇이 들어 있었습니까?",
          options: ["가죽 끈", "뼈와 금속 조각", "나무만", "밧줄"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "채찍질은 잔인한 로마의 형벌이었습니다",
        "군인들은 예수님께 자주색 옷을 입혔습니다",
        "예수님은 이 모든 것을 조용히 견디셨습니다"
      ],
      
      funFacts: [
        "가시 면류관은 죄의 저주를 상징합니다",
        "자주색은 왕의 색으로, 조롱으로 사용되었습니다",
        "예수님의 고난은 이사야의 예언을 성취합니다"
      ]
    },

    45: {
      name: "골고다로 가는 길",
      challenge: "예수님이 십자가를 지신 것에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "예수님은 무엇을 지셨습니까?",
          options: ["깃발", "십자가", "왕관", "칼"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "누가 예수님이 십자가를 지시는 것을 도왔습니까?",
          options: ["베드로", "요한", "구레네 시몬", "요셉"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "골고다는 무엇을 의미합니까?",
          options: ["거룩한 산", "해골 장소", "평화의 장소", "정의의 장소"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "예수님은 약해져서 넘어지셨습니다",
        "여인들이 길에서 울고 있었습니다",
        "행렬은 도시를 통과했습니다"
      ],
      
      funFacts: [
        "십자가의 무게는 약 40-50kg이었습니다",
        "골고다는 성벽 밖에 있었습니다",
        "구레네 시몬은 아프리카에서 왔습니다"
      ]
    },

    46: {
      name: "십자가형",
      challenge: "예수님의 십자가 처형에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "예수님은 몇 명과 함께 십자가에 못 박히셨습니까?",
          options: ["아무도 없음", "한 명", "두 명", "세 명"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "예수님은 십자가에서 무엇이라 말씀하셨습니까: '아버지, 저들을 ___'?",
          options: ["구하소서", "용서하소서", "막으소서", "벌하소서"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "십자가 위의 명패는 무엇이었습니까?",
          options: ["죄인", "유대인의 왕", "반역자", "선지자"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "예수님은 낮 제3시에 십자가에 못 박히셨습니다",
        "군인들은 예수님의 옷을 제비뽑았습니다",
        "예수님은 십자가에서 일곱 말씀을 하셨습니다"
      ],
      
      funFacts: [
        "명패는 세 가지 언어로 쓰여 있었습니다: 히브리어, 라틴어, 그리스어",
        "한 강도가 마지막 순간에 회개했습니다",
        "예수님은 어머니를 요한에게 부탁하셨습니다"
      ]
    },

    47: {
      name: "예수님의 죽음",
      challenge: "예수님의 마지막 시간에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "예수님의 죽음 당시 무슨 일이 일어났습니까?",
          options: ["해가 더 밝게 빛났다", "어둠이 임했다", "비가 내렸다", "무지개가 나타났다"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "성전에서 무엇이 찢어졌습니까?",
          options: ["바닥", "휘장", "벽", "천장"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "예수님의 마지막 말씀은 무엇이었습니까?",
          options: ["다 이루었다", "목마르다", "아버지 내 영혼을 아버지 손에 맡기나이다", "어찌하여 나를 버리셨나이까"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "어둠이 세 시간 동안 계속되었습니다",
        "한 군인이 예수님의 옆구리를 창으로 찔렀습니다",
        "백부장이 '이 사람은 진실로 하나님의 아들이었도다'라고 말했습니다"
      ],
      
      funFacts: [
        "성전 휘장이 위에서 아래로 찢어졌습니다, 사람의 손으로가 아니었습니다",
        "이것은 유월절 기간에 일어났습니다, 어린 양이 희생되는 때였습니다",
        "예수님의 죽음은 죄의 대가를 지불했습니다"
      ]
    },

    48: {
      name: "매장",
      challenge: "예수님의 매장에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "예수님은 누구의 무덤에 안치되셨습니까?",
          options: ["베드로", "아리마대 요셉", "니고데모", "나사로"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "예수님의 몸은 무엇으로 싸였습니까?",
          options: ["자주색 옷", "금빛 옷", "흰 세마포", "아무것도 입히지 않음"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "니고데모는 예수님의 몸을 위해 무엇을 가져왔습니까?",
          options: ["기름", "몰약과 침향", "물", "꽃"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "무덤은 새 바위에 파여 있었습니다",
        "큰 돌이 입구를 막았습니다",
        "경비병들이 무덤을 지키도록 배치되었습니다"
      ],
      
      funFacts: [
        "부자의 무덤이었습니다, 이사야의 예언을 성취하며",
        "안식일이 다가오고 있어서 서둘러 매장했습니다",
        "요셉은 비밀 제자였다가 용기를 내었습니다"
      ]
    },

    49: {
      name: "빈 무덤",
      challenge: "부활절 아침의 발견에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "누가 먼저 무덤이 비어 있는 것을 발견했습니까?",
          options: ["베드로", "요한", "여인들", "군인들"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "돌은 어디에 있었습니까?",
          options: ["깨져 있었다", "굴려져 있었다", "여전히 거기 있었다", "사라졌다"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "여인들은 무덤에서 몇 명의 천사를 만났습니까?",
          options: ["아무도 없음", "한 명", "두 명", "세 명"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "주의 첫날 아침이었습니다",
        "여인들은 예수님의 몸에 기름 붓기 위해 왔습니다",
        "천사들이 복음을 선포했습니다"
      ],
      
      funFacts: [
        "여인들이 첫 번째 증인이었습니다, 혁명적인 세부 사항입니다",
        "베드로와 요한이 무덤으로 달려갔습니다",
        "빈 무덤만으로는 충분하지 않았습니다, 예수님이 나타나셔야 했습니다"
      ]
    },

    50: {
      name: "예수님이 막달라 마리아에게 나타나심",
      challenge: "예수님의 첫 나타나심에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "부활 후 예수님은 먼저 누구에게 나타나셨습니까?",
          options: ["베드로", "요한", "막달라 마리아", "도마"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "마리아는 처음에 예수님을 누구로 착각했습니까?",
          options: ["천사", "동산지기", "군인", "바리새인"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "마리아가 예수님을 알아봤을 때, 예수님은 무엇이라 말씀하셨습니까?",
          options: ["가서 전하라", "나를 만지지 말라", "두려워 말라", "믿으라"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "마리아는 무덤 곁에서 울고 있었습니다",
        "예수님은 그녀의 이름을 부르셨습니다",
        "그녀를 형제들에게 전하도록 보내셨습니다"
      ],
      
      funFacts: [
        "예수님은 첫 나타나심을 위해 여인을 선택하셨습니다",
        "마리아는 첫 번째 사도가 되었습니다",
        "그녀는 예수님을 '랍오니'(선생님)라고 불렀습니다"
      ]
    },

    51: {
      name: "엠마오로 가는 길에서",
      challenge: "길에서의 예수님의 나타나심에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "몇 명의 제자가 엠마오로 가고 있었습니까?",
          options: ["한 명", "두 명", "세 명", "네 명"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "제자들은 언제 예수님을 알아보았습니까?",
          options: ["즉시", "떡을 떼실 때", "길에서", "결코 알아보지 못했다"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "예수님은 길에서 그들에게 무엇을 설명하셨습니까?",
          options: ["미래", "성경", "율법", "기적"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "예수님은 낯선 사람으로 그들과 함께 걸으셨습니다",
        "그분이 말씀하시는 동안 그들의 마음이 뜨거웠습니다",
        "그들이 알아봤을 때 예수님은 사라지셨습니다"
      ],
      
      funFacts: [
        "엠마오는 예루살렘에서 약 11km 떨어져 있었습니다",
        "예수님은 모든 성경이 그분에 대해 말하는 것을 보여주셨습니다",
        "제자들은 즉시 예루살렘으로 달려갔습니다"
      ]
    },

    52: {
      name: "제자들에게 나타나심",
      challenge: "닫힌 방에서의 예수님의 나타나심에 대해 알아보세요",
      
      questions: {
        easy: {
          question: "예수님이 나타나셨을 때 제자들은 어디에 있었습니까?",
          options: ["성전에", "시장에", "닫힌 방에", "겟세마네에"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "예수님은 제자들에게 무엇을 보이셨습니까?",
          options: ["그의 상처", "그의 얼굴", "그의 옷", "빛"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "처음에 어떤 제자가 없었습니까?",
          options: ["베드로", "요한", "도마", "야고보"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "문들은 두려움 때문에 닫혀 있었습니다",
        "예수님은 '너희에게 평강이 있을지어다'라고 말씀하셨습니다",
        "그들에게 숨을 내쉬며 '성령을 받으라'고 말씀하셨습니다"
      ],
      
      funFacts: [
        "예수님은 유령이 아님을 증명하기 위해 그들과 함께 식사하셨습니다",
        "도마는 일주일 후에 믿었습니다",
        "예수님은 40일 동안 여러 번 나타나셨습니다"
      ]
    }
  }
};
